import { Box, Grid, Stack, styled, Typography } from '@mui/material';

export const LayoutEditContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: row;
  padding: 0 !important;
`;

export const StyledLayoutEditContentContainer = styled(Box)(
  ({ theme }) => `
  display: grid;
  grid-template-rows: auto auto auto;
  grid-template-columns: 100%;
  flex: 1;
  flex-direction: column;
  border-left: 1px solid ${theme.palette.secondary.light};
  overflow: auto;
  height: 100%;
`,
);

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 30px 0 30px;
  align-items: flex-start;
`;

export const ActionButtonsContainer = styled(Stack)`
  flex-shrink: 0;
`;

export const LayoutNameText = styled(Typography)`
  padding-right: 16px;
`;
export const SidebarContainer = styled(Box)`
  display: flex;
  position: relative;
  border-right: 1px solid black;
  width: 340px;
`;

export const GridContainer = styled(Grid)`
  align-items: center;
  direction: row;
`;

export const AssemblyScreenWrapper = styled('span')`
  &:nth-child(n + 1) {
    margin-left: -10px;
  }
`;

export const ChipSettingsContainer = styled('div')`
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  justify-content: center;
`;
